import { render } from "./i3.vue?vue&type=template&id=545e8c03&scoped=true"
const script = {}

import "./i3.vue?vue&type=style&index=0&id=545e8c03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545e8c03"]])

export default __exports__